export default "/react/logoLabelUp-9a9e4da2.png";